import { Component } from '@angular/core';
import { LayoutComponent } from '../../shared/layout/layout.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from "../../shared/button/button.component";
import { RouterLink } from '@angular/router';
import { MfaService } from '../../services/mfa.service';

import { ChevronUpIconComponent } from '../../shared/icons/chevron-up/chevron-up.component';

@Component({
  selector: 'app-mfa-setup',
  standalone: true,
  imports: [LayoutComponent, TranslatePipe, ButtonComponent, RouterLink, ChevronUpIconComponent],
  templateUrl: './mfa-setup.component.html',
  styleUrl: './mfa-setup.component.css'
})
export class MfaSetupComponent {
  public openedTabs: string[] = [];

  constructor(
    private mfaService: MfaService
  ) { }

  public toggleTab(id: string): void {
    const existing = this.openedTabs.findIndex((t) => t === id)
    if (existing >= 0) {
      this.openedTabs.splice(existing, 1);
      return;
    }
    this.openedTabs.push(id);
  }

  public isOpened(id: string): boolean {
    return this.openedTabs.findIndex((t) => t === id) >= 0;
  }

  public async generateCodes(): Promise<void> {
    const res = await this.mfaService.generateBackupCodes();
    console.log('res', res);
  }
}
